import { create } from 'zustand';
import { fetchGameArticleTypes } from '../api/games';

const CACHE_DURATION = 60 * 60 * 1000; // 1 hour in milliseconds

interface ArticleTypeStore {
  articleTypes: string[];
  isLoading: boolean;
  error: Error | null;
  lastFetchTimestamp: number | null;
  isFetching: boolean;
  fetchArticleTypes: (getAccessToken: () => Promise<string>) => void;
  invalidateCache: () => void;
}

export const useArticleTypeStore = create<ArticleTypeStore>((set) => ({
  articleTypes: [],
  isLoading: false,
  error: null,
  lastFetchTimestamp: null,
  isFetching: false,
  fetchArticleTypes: async (getAccessToken) => {
    const state = useArticleTypeStore.getState();
    const now = Date.now();

    // If we have a valid cache, return early
    if (state.lastFetchTimestamp && now - state.lastFetchTimestamp < CACHE_DURATION) {
      return;
    }

    // If there's already a request in progress, return early
    if (state.isFetching) {
      return;
    }

    set({ isLoading: true, error: null, isFetching: true });
    try {
      const types = await fetchGameArticleTypes(getAccessToken);
      set({
        articleTypes: types,
        isLoading: false,
        lastFetchTimestamp: now,
        isFetching: false,
      });
    } catch (error) {
      set({ error: error as Error, isLoading: false, isFetching: false });
    }
  },
  invalidateCache: () => {
    set({ lastFetchTimestamp: null });
  },
}));
